import React from 'react';
import { cx } from './cx';

export type BadgeTone = 'success' | 'warning' | 'danger' | 'info' | 'neutral' | 'primary';

export interface BadgeProps {
  tone?: BadgeTone;
  dot?: boolean;
  size?: 'sm' | 'md';
  className?: string;
  children: React.ReactNode;
}

const TONES: Record<BadgeTone, string> = {
  success: 'text-success bg-success/12 border-success/32',
  warning: 'text-warning bg-warning/12 border-warning/32',
  danger: 'text-danger bg-danger/12 border-danger/32',
  info: 'text-info bg-info/12 border-info/32',
  neutral: 'text-secondary bg-action-neutral border-edge',
  primary: 'text-amount-in bg-action-primary/14 border-action-primary/36',
};

/** Status or label pill. Colour carries the meaning; the text carries the words. */
export default function Badge({ tone = 'neutral', dot = true, size = 'md', className, children }: BadgeProps) {
  return (
    <span
      className={cx(
        'inline-flex items-center gap-1.5 rounded-full border font-ui font-semibold text-small leading-none whitespace-nowrap',
        size === 'md' ? 'h-6 px-2.5' : 'h-5 px-2',
        TONES[tone],
        className
      )}
    >
      {dot ? <span className="size-1.5 shrink-0 rounded-full bg-current" aria-hidden /> : null}
      {children}
    </span>
  );
}
